webpackJsonp([22],{

/***/ 1870:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Register; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_apollo__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_simple_react_form__ = __webpack_require__(246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_simple_react_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_simple_react_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_autobind_decorator__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_autobind_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_autobind_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_orionsoft_parts_lib_components_Button__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_orionsoft_parts_lib_components_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_orionsoft_parts_lib_components_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_orionsoft_parts_lib_components_fields_Select__ = __webpack_require__(1998);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_orionsoft_parts_lib_components_fields_Select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_orionsoft_parts_lib_components_fields_Select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_orionsoft_parts_lib_helpers_getQueryParam__ = __webpack_require__(698);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_orionsoft_parts_lib_helpers_getQueryParam___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_orionsoft_parts_lib_helpers_getQueryParam__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__helpers_meteor_apollo_accounts__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_fields_SimpleCheckBox__ = __webpack_require__(2047);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__helpers_countries_available__ = __webpack_require__(4163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__helpers_track__ = __webpack_require__(395);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__i18n_translate__ = __webpack_require__(667);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__i18n__ = __webpack_require__(669);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__ReferralLabel__ = __webpack_require__(4164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__Text__ = __webpack_require__(2022);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__TOS__ = __webpack_require__(2267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__styles_css__ = __webpack_require__(2021);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__styles_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_desc,_value,_class2;function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}var Register=Object(__WEBPACK_IMPORTED_MODULE_3_react_apollo__["withApollo"])(_class=(_class2=function(_React$Component){_inherits(Register,_React$Component);function Register(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Register);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Register.__proto__||Object.getPrototypeOf(Register)).call.apply(_ref,[this].concat(args))),_this),_this.state={},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Register,[{key:'componentDidMount',value:function componentDidMount(){var email=__WEBPACK_IMPORTED_MODULE_9_orionsoft_parts_lib_helpers_getQueryParam___default()('email');var queryString=window.location.search;var urlParams=new URLSearchParams(queryString);var ref=urlParams.get('refId');ref&&localStorage.setItem('refId',ref);var originToken=urlParams.get('originToken');originToken&&localStorage.setItem('originToken',originToken);var utmSource=urlParams.get('utm_source');utmSource&&localStorage.setItem('utm_source',utmSource);var utmMedium=urlParams.get('utm_medium');utmMedium&&localStorage.setItem('utm_medium',utmMedium);var utmCampaign=urlParams.get('utm_campaign');utmCampaign&&localStorage.setItem('utm_campaign',utmCampaign);var utmTerm=urlParams.get('utm_term');utmTerm&&localStorage.setItem('utm_term',utmTerm);var utmContent=urlParams.get('utm_content');utmContent&&localStorage.setItem('utm_content',utmContent);if(email)this.setState({email:email});if(ref)this.setState({profile:{referredBy:ref}});if(originToken){this.setState({profile:{originToken:originToken}});}else if(utmSource||utmMedium||utmCampaign||utmTerm||utmContent){originToken='utm_source:'+utmSource+'|utm_medium:'+utmMedium+'|utm_campaign:'+utmCampaign+'|utm_term:'+utmTerm+'|utm_content:'+utmContent;this.setState({profile:{originToken:originToken}});}}},{key:'login',value:function(){var _ref2=_asyncToGenerator(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:if(this.canRegister()){_context.next=2;break;}return _context.abrupt('return');case 2:if(this.state.accept){_context.next=4;break;}return _context.abrupt('return',this.props.setError('Debes aceptar los terminos y la política de privacidad'));case 4:if(!(this.state.password!==this.state.confirm)){_context.next=6;break;}return _context.abrupt('return',this.props.setError(__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__i18n__["a" /* default */],{tr:'auth.pages.passwordDoesntMatch'})));case 6:if(!(!this.state.profile||!this.state.profile.countryCode)){_context.next=8;break;}return _context.abrupt('return',this.props.setError('Debes indicar el país de residencia'));case 8:this.props.setLoading(true);this.props.setError(null);_context.prev=10;_context.next=13;return Object(__WEBPACK_IMPORTED_MODULE_10__helpers_meteor_apollo_accounts__["a" /* createUser */])(this.state,this.props.client);case 13:Object(__WEBPACK_IMPORTED_MODULE_13__helpers_track__["a" /* default */])({action:'register',category:'auth',label:this.state.email});if(localStorage.getItem('originToken')==='twitter'){window.twq&&window.twq('event','tw-oeqwu-oerpw');}this.props.onSuccess();_context.next=24;break;case 18:_context.prev=18;_context.t0=_context['catch'](10);console.error(_context.t0);Object(__WEBPACK_IMPORTED_MODULE_13__helpers_track__["a" /* default */])({action:'register-error',category:'auth',label:_context.t0.message});this.props.setError(_context.t0.message);this.props.setLoading(false);case 24:case'end':return _context.stop();}}},_callee,this,[[10,18]]);}));function login(){return _ref2.apply(this,arguments);}return login;}()},{key:'handleConfirmKey',value:function handleConfirmKey(event){if(event.charCode===13||event.keyCode===13){this.login();}}},{key:'canRegister',value:function canRegister(){return this.state.email&&this.state.password&&this.state.confirm;}},{key:'renderButtons',value:function renderButtons(){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_19__styles_css___default.a.buttonsContainer},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_orionsoft_parts_lib_components_Button___default.a,{disabled:!this.canRegister(),primary:true,onClick:this.login,className:'tds-orionx-override-btn',fullWidth:true,loading:this.props.isLoading},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__i18n__["a" /* default */],{tr:'auth.pages.register'})));}},{key:'render',value:function render(){var _this2=this;var referredBy=localStorage.getItem('refId');return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_19__styles_css___default.a.formContainer},referredBy&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__ReferralLabel__["a" /* default */],{refId:referredBy}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_simple_react_form__["Form"],{state:this.state,onChange:function onChange(changes){return _this2.setState(changes);},onSubmit:this.login},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_simple_react_form__["Field"],{fieldName:'email',type:__WEBPACK_IMPORTED_MODULE_17__Text__["a" /* default */],fieldType:'email',className:'tds-orionx-input',placeholder:Object(__WEBPACK_IMPORTED_MODULE_14__i18n_translate__["a" /* default */])('auth.pages.email')}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_simple_react_form__["Field"],{fieldName:'password',type:__WEBPACK_IMPORTED_MODULE_17__Text__["a" /* default */],fieldType:'password',className:'tds-orionx-input',placeholder:Object(__WEBPACK_IMPORTED_MODULE_14__i18n_translate__["a" /* default */])('auth.pages.password')}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_simple_react_form__["Field"],{fieldName:'confirm',type:__WEBPACK_IMPORTED_MODULE_17__Text__["a" /* default */],fieldType:'password',className:'tds-orionx-input',placeholder:Object(__WEBPACK_IMPORTED_MODULE_14__i18n_translate__["a" /* default */])('auth.pages.confirmPassword'),onKeyPress:this.handleConfirmKey}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_simple_react_form__["Field"],{fieldName:'profile.countryCode',type:__WEBPACK_IMPORTED_MODULE_8_orionsoft_parts_lib_components_fields_Select___default.a,placeholder:Object(__WEBPACK_IMPORTED_MODULE_14__i18n_translate__["a" /* default */])('auth.pages.country'),style:{backgroundColor:'#fff'},className:'tds-orionx-override-dropdown',options:__WEBPACK_IMPORTED_MODULE_12__helpers_countries_available__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_simple_react_form__["Field"],{fieldName:'accept',type:__WEBPACK_IMPORTED_MODULE_11__components_fields_SimpleCheckBox__["a" /* default */]},'Acepto la',' ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["Link"],{to:'/privacy-policy',target:'_blank'},'Pol\xEDtica de privacidad'),' ','y los',' ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["Link"],{to:'/terms-and-conditions',target:'_blank'},'T\xE9rminos y condiciones'))),this.renderButtons(),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__i18n__["a" /* default */],{tr:'auth.pages.otherLinksInRegister'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__TOS__["a" /* default */],null));}}]);return Register;}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component),(_applyDecoratedDescriptor(_class2.prototype,'login',[__WEBPACK_IMPORTED_MODULE_6_autobind_decorator___default.a],Object.getOwnPropertyDescriptor(_class2.prototype,'login'),_class2.prototype),_applyDecoratedDescriptor(_class2.prototype,'handleConfirmKey',[__WEBPACK_IMPORTED_MODULE_6_autobind_decorator___default.a],Object.getOwnPropertyDescriptor(_class2.prototype,'handleConfirmKey'),_class2.prototype)),_class2))||_class;Register.propTypes={setLoading:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,setError:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,onSuccess:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,isLoading:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,client:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object};

/***/ }),

/***/ 1998:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = __webpack_require__(32);

var _extends3 = _interopRequireDefault(_extends2);

var _regenerator = __webpack_require__(24);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(155);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _classCallCheck2 = __webpack_require__(6);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(9);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _desc, _value, _class, _class2, _temp2;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactSelect = __webpack_require__(666);

var _autobindDecorator = __webpack_require__(28);

var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var Select = (_class = (_temp2 = _class2 = function (_React$Component) {
  (0, _inherits3.default)(Select, _React$Component);

  function Select() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Select);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Select.__proto__ || Object.getPrototypeOf(Select)).call.apply(_ref, [this].concat(args))), _this), _this.state = {}, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Select, [{
    key: 'onChange',
    value: function onChange(item) {
      var items = this.props.multi ? item : item ? [item] : [];
      if (items.length) {
        var values = items.map(function (item) {
          return item.value;
        });
        var finalValue = this.props.multi ? values : values[0];
        this.props.onChange(finalValue);
      } else {
        this.props.onChange(null);
      }
    }
  }, {
    key: 'loadOptions',
    value: function () {
      var _ref2 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(input, callback) {
        var options;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.props.loadOptions(input);

              case 2:
                options = _context.sent;

                callback(null, { options: options });

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function loadOptions(_x, _x2) {
        return _ref2.apply(this, arguments);
      }

      return loadOptions;
    }()
  }, {
    key: 'filterOption',
    value: function filterOption() {
      var _props;

      if (this.props.filterOption) return (_props = this.props).filterOption.apply(_props, arguments);
      return true;
    }
  }, {
    key: 'getFilterOption',
    value: function getFilterOption() {
      if (!this.props.loadOptions) return { options: this.props.options };
      return { filterOption: this.filterOption, loadOptions: this.loadOptions };
    }
  }, {
    key: 'render',
    value: function render() {
      var Comp = this.props.loadOptions ? _reactSelect.AsyncCreatable : _reactSelect.Creatable;
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(Comp, (0, _extends3.default)({
          multi: this.props.multi,
          name: this.props.fieldName,
          value: this.props.value,
          isValidNewOption: this.props.isValidNewOption,
          onChange: this.onChange
        }, this.getFilterOption(), this.props.passProps)),
        _react2.default.createElement(
          'div',
          { className: 'os-input-error' },
          this.props.errorMessage
        )
      );
    }
  }]);
  return Select;
}(_react2.default.Component), _class2.propTypes = {
  fieldName: _propTypes2.default.string,
  onChange: _propTypes2.default.func,
  value: _propTypes2.default.any,
  passProps: _propTypes2.default.object,
  multi: _propTypes2.default.bool,
  options: _propTypes2.default.array,
  errorMessage: _propTypes2.default.node,
  loadOptions: _propTypes2.default.func,
  isValidNewOption: _propTypes2.default.func,
  filterOption: _propTypes2.default.func
}, _class2.defaultProps = {
  isValidNewOption: function isValidNewOption() {
    return false;
  }
}, _temp2), (_applyDecoratedDescriptor(_class.prototype, 'onChange', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'onChange'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'loadOptions', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'loadOptions'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'filterOption', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'filterOption'), _class.prototype)), _class);
exports.default = Select;

/***/ }),

/***/ 2021:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2025);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(1867)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--1-oneOf-2-2!../../../../node_modules/postcss-loader/lib/index.js??postcss!./styles.css", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--1-oneOf-2-2!../../../../node_modules/postcss-loader/lib/index.js??postcss!./styles.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 2022:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Text; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles_css__ = __webpack_require__(2023);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__styles_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Text=function(_React$Component){_inherits(Text,_React$Component);function Text(){_classCallCheck(this,Text);return _possibleConstructorReturn(this,(Text.__proto__||Object.getPrototypeOf(Text)).apply(this,arguments));}_createClass(Text,[{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_1__styles_css___default.a.container},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',Object.assign({ref:'input',className:__WEBPACK_IMPORTED_MODULE_1__styles_css___default.a.input,type:this.props.fieldType,value:this.props.value||'',placeholder:this.props.placeholder,onChange:function onChange(event){return _this2.props.onChange(event.target.value);}},this.props.passProps)));}}]);return Text;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);Text.propTypes={onChange:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,value:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,fieldType:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,passProps:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,placeholder:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node};Text.defaultProps={fieldType:'text'};

/***/ }),

/***/ 2023:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2024);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(1867)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--1-oneOf-2-2!../../../../../node_modules/postcss-loader/lib/index.js??postcss!./styles.css", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js??ref--1-oneOf-2-2!../../../../../node_modules/postcss-loader/lib/index.js??postcss!./styles.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 2024:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1866)(true);
// imports


// module
exports.push([module.i, ".nj9CDfOahI6GOfpmn5zDP{width:100%}._27sU7_Qo5tK5UeKmzpTD9H{width:100%;-webkit-box-sizing:border-box;box-sizing:border-box;font-size:20px;font-family:inherit;border:none;border-radius:5px;background-color:#eee;padding:10px}._27sU7_Qo5tK5UeKmzpTD9H:focus{outline:none}", "", {"version":3,"sources":["/home/runner/work/frontend/frontend/src/App/Pages/Auth/Text/styles.css"],"names":[],"mappings":"AAAA,uBACE,UAAY,CACb,AAED,yBACE,WAAY,AACZ,8BAA+B,AACvB,sBAAuB,AAC/B,eAAgB,AAChB,oBAAqB,AACrB,YAAa,AACb,kBAAmB,AACnB,sBAAuB,AACvB,YAAc,CACf,AAED,+BACE,YAAc,CACf","file":"styles.css","sourcesContent":[":local(.container) {\n  width: 100%;\n}\n\n:local(.input) {\n  width: 100%;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  font-size: 20px;\n  font-family: inherit;\n  border: none;\n  border-radius: 5px;\n  background-color: #eee;\n  padding: 10px;\n}\n\n:local(.input):focus {\n  outline: none;\n}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"container": "nj9CDfOahI6GOfpmn5zDP",
	"input": "_27sU7_Qo5tK5UeKmzpTD9H"
};

/***/ }),

/***/ 2025:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1866)(true);
// imports


// module
exports.push([module.i, "._3Jyn_TD7snrLWTGm6KqUBZ{font-size:13px}.CMkscYnZVp_yMGKvabQf_{width:100%}.KRdyDVMGdE2W7PlOB2u6q{margin-top:30px;text-align:center}._2CofCoXoThcR89ZB-TptjR{color:red;text-align:center;margin-bottom:20px;margin-top:-20px}.LWOyy0ZQUlIEyTXRE0H0J{color:#fff;margin-bottom:10px;width:100%}._2UxL-ZJU6a381cNeaBZBcE{background-color:#3b5998}._2UxL-ZJU6a381cNeaBZBcE:active{background-color:#324d86}.Z9dBBBpZIcWb6pptj1nAD{background-color:#db4437}.Z9dBBBpZIcWb6pptj1nAD:active{background-color:#af352a}._3gDOlklnOum3GgAOqmb8JS{background-color:#0077b5}._3gDOlklnOum3GgAOqmb8JS:active{background-color:#0a699a}._3P9tnFLXyk_70c7ERz_5s0{margin-bottom:30px}._64RYC3yGq3nbToENFWyWU{font-size:16px;font-weight:700;color:#1d79ff;font-family:monospace}", "", {"version":3,"sources":["/home/runner/work/frontend/frontend/src/App/Pages/Auth/styles.css"],"names":[],"mappings":"AAAA,yBACE,cAAgB,CACjB,AAED,uBACE,UAAY,CACb,AAED,uBACE,gBAAiB,AACjB,iBAAmB,CACpB,AAED,yBACE,UAAW,AACX,kBAAmB,AACnB,mBAAoB,AACpB,gBAAkB,CACnB,AAED,uBACE,WAAa,AACb,mBAAoB,AACpB,UAAY,CACb,AAED,yBAEE,wBAA0B,CAC3B,AAED,gCACE,wBAA0B,CAC3B,AAED,uBAEE,wBAA0B,CAC3B,AAED,8BACE,wBAA0B,CAC3B,AAED,yBAEE,wBAA0B,CAC3B,AAED,gCACE,wBAA0B,CAC3B,AAED,yBACE,kBAAoB,CACrB,AAED,wBACE,eAAgB,AAChB,gBAAkB,AAClB,cAAe,AACf,qBAAuB,CACxB","file":"styles.css","sourcesContent":[":local(.tos) {\n  font-size: 13px;\n}\n\n:local(.formContainer) {\n  width: 100%;\n}\n\n:local(.buttonsContainer) {\n  margin-top: 30px;\n  text-align: center;\n}\n\n:local(.error) {\n  color: red;\n  text-align: center;\n  margin-bottom: 20px;\n  margin-top: -20px;\n}\n\n:local(.social-button) {\n  color: white;\n  margin-bottom: 10px;\n  width: 100%;\n}\n\n:local(.facebook) {\n  composes: social-button;\n  background-color: #3b5998;\n}\n\n:local(.facebook):active {\n  background-color: #324d86;\n}\n\n:local(.google) {\n  composes: social-button;\n  background-color: #db4437;\n}\n\n:local(.google):active {\n  background-color: #af352a;\n}\n\n:local(.linkedin) {\n  composes: social-button;\n  background-color: #0077b5;\n}\n\n:local(.linkedin):active {\n  background-color: #0a699a;\n}\n\n:local(.social) {\n  margin-bottom: 30px;\n}\n\n:local(.refId) {\n  font-size: 16px;\n  font-weight: bold;\n  color: #1d79ff;\n  font-family: monospace;\n}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"tos": "_3Jyn_TD7snrLWTGm6KqUBZ",
	"formContainer": "CMkscYnZVp_yMGKvabQf_",
	"buttonsContainer": "KRdyDVMGdE2W7PlOB2u6q",
	"error": "_2CofCoXoThcR89ZB-TptjR",
	"social-button": "LWOyy0ZQUlIEyTXRE0H0J",
	"facebook": "_2UxL-ZJU6a381cNeaBZBcE LWOyy0ZQUlIEyTXRE0H0J",
	"google": "Z9dBBBpZIcWb6pptj1nAD LWOyy0ZQUlIEyTXRE0H0J",
	"linkedin": "_3gDOlklnOum3GgAOqmb8JS LWOyy0ZQUlIEyTXRE0H0J",
	"social": "_3P9tnFLXyk_70c7ERz_5s0",
	"refId": "_64RYC3yGq3nbToENFWyWU"
};

/***/ }),

/***/ 2047:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SimpleCheckBox; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles_css__ = __webpack_require__(2048);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__styles_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SimpleCheckBox=function(_React$Component){_inherits(SimpleCheckBox,_React$Component);function SimpleCheckBox(){_classCallCheck(this,SimpleCheckBox);return _possibleConstructorReturn(this,(SimpleCheckBox.__proto__||Object.getPrototypeOf(SimpleCheckBox)).apply(this,arguments));}_createClass(SimpleCheckBox,[{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_1__styles_css___default.a.container},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{disabled:this.props.disabled,type:'checkbox',checked:this.props.value,onChange:function onChange(){return _this2.props.onChange(!_this2.props.value);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:__WEBPACK_IMPORTED_MODULE_1__styles_css___default.a.label},this.props.children)));}}]);return SimpleCheckBox;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);SimpleCheckBox.propTypes={children:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node,value:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,onChange:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,disabled:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool};

/***/ }),

/***/ 2048:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2049);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(1867)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--1-oneOf-2-2!../../../../../node_modules/postcss-loader/lib/index.js??postcss!./styles.css", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js??ref--1-oneOf-2-2!../../../../../node_modules/postcss-loader/lib/index.js??postcss!./styles.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 2049:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1866)(true);
// imports


// module
exports.push([module.i, "._1MQo232OA2aiiwcbNZL44A{margin-left:5px}", "", {"version":3,"sources":["/home/runner/work/frontend/frontend/src/App/components/fields/SimpleCheckBox/styles.css"],"names":[],"mappings":"AAGA,yBACE,eAAiB,CAClB","file":"styles.css","sourcesContent":[":local(.container) {\n}\n\n:local(.label) {\n  margin-left: 5px;\n}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"container": "_2in0xqYu2TEggl4gLn67YT",
	"label": "_1MQo232OA2aiiwcbNZL44A"
};

/***/ }),

/***/ 2267:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TOS; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/* import styles from './styles.css'
import Translate from 'App/i18n' */var TOS=function(_React$Component){_inherits(TOS,_React$Component);function TOS(){_classCallCheck(this,TOS);return _possibleConstructorReturn(this,(TOS.__proto__||Object.getPrototypeOf(TOS)).apply(this,arguments));}_createClass(TOS,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null);/* return (
      <div className={styles.tos}>
        <Translate tr="auth.tos.tos" html />
      </div>
    ) */}}]);return TOS;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);TOS.propTypes={};

/***/ }),

/***/ 4163:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([// {label: 'Afghanistan', value: 'AF'},
// {label: 'Åland Islands', value: 'AX'},
// {label: 'Albania', value: 'AL'},
// {label: 'Algeria', value: 'DZ'},
// {label: 'American Samoa', value: 'AS'},
// {label: 'AndorrA', value: 'AD'},
// {label: 'Angola', value: 'AO'},
// {label: 'Anguilla', value: 'AI'},
// {label: 'Antarctica', value: 'AQ'},
// {label: 'Antigua and Barbuda', value: 'AG'},
{label:'Argentina',value:'AR'},// {label: 'Armenia', value: 'AM'},
// {label: 'Aruba', value: 'AW'},
// {label: 'Australia', value: 'AU'},
// {label: 'Austria', value: 'AT'},
// {label: 'Azerbaijan', value: 'AZ'},
// {label: 'Bahamas', value: 'BS'},
// {label: 'Bahrain', value: 'BH'},
// {label: 'Bangladesh', value: 'BD'},
// {label: 'Barbados', value: 'BB'},
// {label: 'Belarus', value: 'BY'},
// {label: 'Belgium', value: 'BE'},
// {label: 'Belize', value: 'BZ'},
// {label: 'Benin', value: 'BJ'},
// {label: 'Bermuda', value: 'BM'},
// {label: 'Bhutan', value: 'BT'},
// {label: 'Bolivia', value: 'BO'},
// {label: 'Bosnia and Herzegovina', value: 'BA'},
// {label: 'Botswana', value: 'BW'},
// {label: 'Bouvet Island', value: 'BV'},
// {label: 'Brazil', value: 'BR'},
// {label: 'British Indian Ocean Territory', value: 'IO'},
// {label: 'Brunei Darussalam', value: 'BN'},
// {label: 'Bulgaria', value: 'BG'},
// {label: 'Burkina Faso', value: 'BF'},
// {label: 'Burundi', value: 'BI'},
// {label: 'Cambodia', value: 'KH'},
// {label: 'Cameroon', value: 'CM'},
// {label: 'Canada', value: 'CA'},
// {label: 'Cape Verde', value: 'CV'},
// {label: 'Cayman Islands', value: 'KY'},
// {label: 'Central African Republic', value: 'CF'},
// {label: 'Chad', value: 'TD'},
{label:'Chile',value:'CL'},// {label: 'China', value: 'CN'},
// {label: 'Christmas Island', value: 'CX'},
// {label: 'Cocos (Keeling) Islands', value: 'CC'},
// {label: 'Colombia', value: 'CO'},
// {label: 'Comoros', value: 'KM'},
// {label: 'Congo', value: 'CG'},
// {label: 'Congo, The Democratic Republic of the', value: 'CD'},
// {label: 'Cook Islands', value: 'CK'},
// {label: 'Costa Rica', value: 'CR'},
// {label: "Cote D'Ivoire", value: 'CI'},
// {label: 'Croatia', value: 'HR'},
// {label: 'Cuba', value: 'CU'},
// {label: 'Cyprus', value: 'CY'},
// {label: 'Czech Republic', value: 'CZ'},
// {label: 'Denmark', value: 'DK'},
// {label: 'Djibouti', value: 'DJ'},
// {label: 'Dominica', value: 'DM'},
// {label: 'Dominican Republic', value: 'DO'},
// {label: 'Ecuador', value: 'EC'},
// {label: 'Egypt', value: 'EG'},
// {label: 'El Salvador', value: 'SV'},
// {label: 'Equatorial Guinea', value: 'GQ'},
// {label: 'Eritrea', value: 'ER'},
// {label: 'Estonia', value: 'EE'},
// {label: 'Ethiopia', value: 'ET'},
// {label: 'Falkland Islands (Malvinas)', value: 'FK'},
// {label: 'Faroe Islands', value: 'FO'},
// {label: 'Fiji', value: 'FJ'},
// {label: 'Finland', value: 'FI'},
// {label: 'France', value: 'FR'},
// {label: 'French Guiana', value: 'GF'},
// {label: 'French Polynesia', value: 'PF'},
// {label: 'French Southern Territories', value: 'TF'},
// {label: 'Gabon', value: 'GA'},
// {label: 'Gambia', value: 'GM'},
// {label: 'Georgia', value: 'GE'},
// {label: 'Germany', value: 'DE'},
// {label: 'Ghana', value: 'GH'},
// {label: 'Gibraltar', value: 'GI'},
// {label: 'Greece', value: 'GR'},
// {label: 'Greenland', value: 'GL'},
// {label: 'Grenada', value: 'GD'},
// {label: 'Guadeloupe', value: 'GP'},
// {label: 'Guam', value: 'GU'},
// {label: 'Guatemala', value: 'GT'},
// {label: 'Guernsey', value: 'GG'},
// {label: 'Guinea', value: 'GN'},
// {label: 'Guinea-Bissau', value: 'GW'},
// {label: 'Guyana', value: 'GY'},
// {label: 'Haiti', value: 'HT'},
// {label: 'Heard Island and Mcdonald Islands', value: 'HM'},
// {label: 'Holy See (Vatican City State)', value: 'VA'},
// {label: 'Honduras', value: 'HN'},
// {label: 'Hong Kong', value: 'HK'},
// {label: 'Hungary', value: 'HU'},
// {label: 'Iceland', value: 'IS'},
// {label: 'India', value: 'IN'},
// {label: 'Indonesia', value: 'ID'},
// {label: 'Iran, Islamic Republic Of', value: 'IR'},
// {label: 'Iraq', value: 'IQ'},
// {label: 'Ireland', value: 'IE'},
// {label: 'Isle of Man', value: 'IM'},
// {label: 'Israel', value: 'IL'},
// {label: 'Italy', value: 'IT'},
// {label: 'Jamaica', value: 'JM'},
// {label: 'Japan', value: 'JP'},
// {label: 'Jersey', value: 'JE'},
// {label: 'Jordan', value: 'JO'},
// {label: 'Kazakhstan', value: 'KZ'},
// {label: 'Kenya', value: 'KE'},
// {label: 'Kiribati', value: 'KI'},
// {label: "Korea, Democratic People'S Republic of", value: 'KP'},
// {label: 'Korea, Republic of', value: 'KR'},
// {label: 'Kuwait', value: 'KW'},
// {label: 'Kyrgyzstan', value: 'KG'},
// {label: "Lao People'S Democratic Republic", value: 'LA'},
// {label: 'Latvia', value: 'LV'},
// {label: 'Lebanon', value: 'LB'},
// {label: 'Lesotho', value: 'LS'},
// {label: 'Liberia', value: 'LR'},
// {label: 'Libyan Arab Jamahiriya', value: 'LY'},
// {label: 'Liechtenstein', value: 'LI'},
// {label: 'Lithuania', value: 'LT'},
// {label: 'Luxembourg', value: 'LU'},
// {label: 'Macao', value: 'MO'},
// {label: 'Macedonia, The Former Yugoslav Republic of', value: 'MK'},
// {label: 'Madagascar', value: 'MG'},
// {label: 'Malawi', value: 'MW'},
// {label: 'Malaysia', value: 'MY'},
// {label: 'Maldives', value: 'MV'},
// {label: 'Mali', value: 'ML'},
// {label: 'Malta', value: 'MT'},
// {label: 'Marshall Islands', value: 'MH'},
// {label: 'Martinique', value: 'MQ'},
// {label: 'Mauritania', value: 'MR'},
// {label: 'Mauritius', value: 'MU'},
// {label: 'Mayotte', value: 'YT'},
// {label: 'Mexico', value: 'MX'},
// {label: 'Micronesia, Federated States of', value: 'FM'},
// {label: 'Moldova, Republic of', value: 'MD'},
// {label: 'Monaco', value: 'MC'},
// {label: 'Mongolia', value: 'MN'},
// {label: 'Montserrat', value: 'MS'},
// {label: 'Morocco', value: 'MA'},
// {label: 'Mozambique', value: 'MZ'},
// {label: 'Myanmar', value: 'MM'},
// {label: 'Namibia', value: 'NA'},
// {label: 'Nauru', value: 'NR'},
// {label: 'Nepal', value: 'NP'},
// {label: 'Netherlands', value: 'NL'},
// {label: 'Netherlands Antilles', value: 'AN'},
// {label: 'New Caledonia', value: 'NC'},
// {label: 'New Zealand', value: 'NZ'},
// {label: 'Nicaragua', value: 'NI'},
// {label: 'Niger', value: 'NE'},
// {label: 'Nigeria', value: 'NG'},
// {label: 'Niue', value: 'NU'},
// {label: 'Norfolk Island', value: 'NF'},
// {label: 'Northern Mariana Islands', value: 'MP'},
// {label: 'Norway', value: 'NO'},
// {label: 'Oman', value: 'OM'},
// {label: 'Pakistan', value: 'PK'},
// {label: 'Palau', value: 'PW'},
// {label: 'Palestinian Territory, Occupied', value: 'PS'},
// {label: 'Panama', value: 'PA'},
// {label: 'Papua New Guinea', value: 'PG'},
// {label: 'Paraguay', value: 'PY'},
{label:'Perú',value:'PE'},// {label: 'Philippines', value: 'PH'},
// {label: 'Pitcairn', value: 'PN'},
// {label: 'Poland', value: 'PL'},
// {label: 'Portugal', value: 'PT'},
// {label: 'Puerto Rico', value: 'PR'},
// {label: 'Qatar', value: 'QA'},
// {label: 'Reunion', value: 'RE'},
// {label: 'Romania', value: 'RO'},
// {label: 'Russian Federation', value: 'RU'},
// {label: 'RWANDA', value: 'RW'},
// {label: 'Saint Helena', value: 'SH'},
// {label: 'Saint Kitts and Nevis', value: 'KN'},
// {label: 'Saint Lucia', value: 'LC'},
// {label: 'Saint Pierre and Miquelon', value: 'PM'},
// {label: 'Saint Vincent and the Grenadines', value: 'VC'},
// {label: 'Samoa', value: 'WS'},
// {label: 'San Marino', value: 'SM'},
// {label: 'Sao Tome and Principe', value: 'ST'},
// {label: 'Saudi Arabia', value: 'SA'},
// {label: 'Senegal', value: 'SN'},
// {label: 'Serbia and Montenegro', value: 'CS'},
// {label: 'Seychelles', value: 'SC'},
// {label: 'Sierra Leone', value: 'SL'},
// {label: 'Singapore', value: 'SG'},
// {label: 'Slovakia', value: 'SK'},
// {label: 'Slovenia', value: 'SI'},
// {label: 'Solomon Islands', value: 'SB'},
// {label: 'Somalia', value: 'SO'},
// {label: 'South Africa', value: 'ZA'},
// {label: 'South Georgia and the South Sandwich Islands', value: 'GS'},
// {label: 'Spain', value: 'ES'},
// {label: 'Sri Lanka', value: 'LK'},
// {label: 'Sudan', value: 'SD'},
// {label: 'Surilabel', value: 'SR'},
// {label: 'Svalbard and Jan Mayen', value: 'SJ'},
// {label: 'Swaziland', value: 'SZ'},
// {label: 'Sweden', value: 'SE'},
// {label: 'Switzerland', value: 'CH'},
// {label: 'Syrian Arab Republic', value: 'SY'},
// {label: 'Taiwan, Province of China', value: 'TW'},
// {label: 'Tajikistan', value: 'TJ'},
// {label: 'Tanzania, United Republic of', value: 'TZ'},
// {label: 'Thailand', value: 'TH'},
// {label: 'Timor-Leste', value: 'TL'},
// {label: 'Togo', value: 'TG'},
// {label: 'Tokelau', value: 'TK'},
// {label: 'Tonga', value: 'TO'},
// {label: 'Trinidad and Tobago', value: 'TT'},
// {label: 'Tunisia', value: 'TN'},
// {label: 'Turkey', value: 'TR'},
// {label: 'Turkmenistan', value: 'TM'},
// {label: 'Turks and Caicos Islands', value: 'TC'},
// {label: 'Tuvalu', value: 'TV'},
// {label: 'Uganda', value: 'UG'},
// {label: 'Ukraine', value: 'UA'},
// {label: 'United Arab Emirates', value: 'AE'},
// {label: 'United Kingdom', value: 'GB'},
// {label: 'United States', value: 'US'},
// {label: 'United States Minor Outlying Islands', value: 'UM'},
// {label: 'Uruguay', value: 'UY'},
// {label: 'Uzbekistan', value: 'UZ'},
// {label: 'Vanuatu', value: 'VU'},
{label:'Venezuela',value:'VE'// {label: 'Viet Nam', value: 'VN'},
// {label: 'Virgin Islands, British', value: 'VG'},
// {label: 'Virgin Islands, U.S.', value: 'VI'},
// {label: 'Wallis and Futuna', value: 'WF'},
// {label: 'Western Sahara', value: 'EH'},
// {label: 'Yemen', value: 'YE'},
// {label: 'Zambia', value: 'ZM'},
// {label: 'Zimbabwe', value: 'ZW'}
}]);

/***/ }),

/***/ 4164:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = ReferralLabel;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles_css__ = __webpack_require__(2021);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__styles_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_DashedLabel__ = __webpack_require__(4165);
function ReferralLabel(_ref){var refId=_ref.refId;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_DashedLabel__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Est\xE1s usando el c\xF3digo de referidos: ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:__WEBPACK_IMPORTED_MODULE_1__styles_css___default.a.refId},refId)));}

/***/ }),

/***/ 4165:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = DashedLabel;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles_css__ = __webpack_require__(4166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__styles_css__);
function DashedLabel(_ref){var children=_ref.children;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_1__styles_css___default.a.container},children);}

/***/ }),

/***/ 4166:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(4167);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(1867)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--1-oneOf-2-2!../../../../node_modules/postcss-loader/lib/index.js??postcss!./styles.css", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--1-oneOf-2-2!../../../../node_modules/postcss-loader/lib/index.js??postcss!./styles.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 4167:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1866)(true);
// imports


// module
exports.push([module.i, "._2wLJ7_ISgjRTktd9UiMpP0{margin-bottom:20px;height:30px;border-radius:4px;border:3px dashed #1c79ff;display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;padding:7px}", "", {"version":3,"sources":["/home/runner/work/frontend/frontend/src/App/components/DashedLabel/styles.css"],"names":[],"mappings":"AAAA,yBACE,mBAAoB,AACpB,YAAa,AACb,kBAAmB,AACnB,0BAA2B,AAC3B,oBAAqB,AACrB,aAAc,AACd,sBAAuB,AACnB,mBAAoB,AACxB,WAAa,CACd","file":"styles.css","sourcesContent":[":local(.container) {\n  margin-bottom: 20px;\n  height: 30px;\n  border-radius: 4px;\n  border: 3px #1c79ff dashed;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n  padding: 7px;\n}\n\n/* font-size: 15px;\n    font-weight: bold;\n    color: #1d79ff;\n    font-family: monospace;\n} */\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"container": "_2wLJ7_ISgjRTktd9UiMpP0"
};

/***/ })

});


// WEBPACK FOOTER //
// static/js/22.99520d23.chunk.js